import { BrowserRouter as Router, Switch } from "react-router-dom";
import Route from "components/route";
import {
    Services,
    Blogs,
    Blog,
    AboutUs,
    ContactUs,
    Policy,
    Login,
    Clients,
    Project,
    Projects,
    Dashboard,
    NotFound,
    DeepDive,
    Sentiment,
    ForgotPassword,
    ReactionLists,
    ReactionList,
    CrisisMonitoring,
    CrisisMontoringLists,
    LandingPage,
    CompetitorTracking,
    Profile,
    ContactManagement,
    Landing,
    PasswordSetup,
    NewProject,
    PerformanceMeasurement,
    TopAuthors,
} from "pages";
import TutorialDocument from "pages/app/mentor";
import ContentClassification from "pages/app/content-classification";
import InfluencerComparison from "components/app/project/influencer-comparison";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useEffect } from "react";
import api from "api";
import { actions } from "redux/reducers";
import { useDispatch, useSelector } from "react-redux";
import ReportDownload from "components/app/report/report-download";
import { RootState } from "types";
import ReportDownloadOld from "components/app/report/report-download-old";
import BrandInfluencer from "pages/app/profile/brand-influencer";
import Treeview from "pages/app/Treeview";
import NotificationManagement from "pages/app/notification-management/notification-management";
import Admin from "pages/app/admin/admin";

function App() {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user);

    useEffect(() => {
        if (user) {
            api.core.getCoreOptionsAll().then((data) => {
                dispatch(actions.core.set(data));
            });

            api.report.getReportOptions().then((data) => {
                dispatch(actions.reportOptions.set(data));
            });
        }
    }, [dispatch, user]);

    return (
        <>
            <ToastContainer />
            <Router>
                <Switch>
                    {/* CORPORATE */}
                    {/* <Route path="/" component={Login} isPublic exact showHeader={false} showSidenav={false} />
          <Route path="/services" component={Services} isPublic exact showHeader={false} showSidenav={false} />
          <Route path="/blog/:uniqueURL" component={Blog} isPublic exact showHeader={false} showSidenav={false} />
          <Route path="/blogs" component={Blogs} isPublic exact showHeader={false} showSidenav={false} />
          <Route path="/about-us" component={AboutUs} isPublic exact showHeader={false} showSidenav={false} />
          <Route path="/contact-us" component={ContactUs} isPublic exact showHeader={false} showSidenav={false} />
          <Route path="/policy" component={Policy} isPublic exact showHeader={false} showSidenav={false} />
          <Route path="/landing" component={Login} isPublic exact showHeader={false} showSidenav={false} /> */}

                    {/* APP */}
                    <Route path="/" component={Clients} validateToken exact showSidenav={false} />
                    <Route path="/landing" component={Login} exact showHeader={false} />
                    <Route path="/admin" component={Admin} exact showHeader={false} />
                    <Route path="/clients" component={Clients} validateToken exact showSidenav={false} />
                    <Route path="/brandInfluencer" component={BrandInfluencer} exact showHeader={false} />
                    <Route path="/profile" component={Profile} exact showHeader={false} />
                    <Route path="/login" component={Login} exact showHeader={false} />
                    <Route path="/forgot-password" component={ForgotPassword} exact showHeader={false} />
                    <Route path="/forgotpasswordnew" component={ForgotPassword} exact showHeader={false} />
                    <Route path="/password-setup/:contactId" component={PasswordSetup} exact showHeader={false} />
                    <Route path="/client/:clientId/projects" component={Projects} validateToken exact showSidenav={false} />
                    <Route path="/client/:clientId/projects" component={Projects} validateToken exact showSidenav={false} />
                    <Route path="/mentor/document/:fileName" component={TutorialDocument} validateToken exact />
                    <Route path="/client/:clientId/dashboard" component={Dashboard} validateToken exact showSidenav={false} />
                    <Route path="/client/:clientId/new-project" component={NewProject} validateToken exact showSidenav={false} />
                    <Route path="/client/:clientId/contact-management" component={ContactManagement} validateToken exact showSidenav={false} />
                    <Route path="/client/:clientId/project/:projectId" component={Project} validateToken exact />
                    {/* <Route path="/client/:clientId/project/:projectId/sortbins" component={Sortbins} validateToken exact /> */}
                    <Route path="/client/:clientId/project/:projectId/top-authors" component={TopAuthors} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/sentiment" component={Sentiment} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/deep-dive" component={DeepDive} validateToken exact />
                    {/* <Route path="/client/:clientId/project/:projectId/input-bins" component={InputBins} validateToken exact /> */}
                    <Route path="/client/:clientId/project/:projectId/influencer-comparison" component={InfluencerComparison} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/reaction-lists" component={ReactionLists} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/competitor-tracking" component={CompetitorTracking} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/content-classification" component={ContentClassification} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/crisis-lists" component={CrisisMontoringLists} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/crisis-monitoring-lists" component={CrisisMontoringLists} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/performance-measurement" component={PerformanceMeasurement} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/treeview" component={Treeview} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/reaction-list/wordbin/:reactionListId" component={ReactionList} validateToken exact />
                    <Route path="/client/:clientId/project/:projectId/crisis-monitoring/wordbin/:reactionListId" component={CrisisMonitoring} validateToken exact />
                    <Route path="/report/:layoutId/:guid" component={ReportDownload} validateToken exact showSidenav={false} />
                    <Route path="/report/download" component={ReportDownloadOld} validateToken exact showSidenav={false} />
                    <Route path="/contact/notifications" component={NotificationManagement} validateToken exact />

                    {/* FALLBACK */}
                    <Route component={NotFound} />
                </Switch>
            </Router>
        </>
    );
}

export default App;
